// extracted by mini-css-extract-plugin
export default {"weight":"GearForm_weight__xZa3s","scrape":"GearForm_scrape__gwiqV","scrapeInput":"GearForm_scrapeInput__ZjlDB","create":"GearForm_create__kdgMQ"};